module.exports = __webpack_public_path__ + "static/media/play.a195ab2a.svg";